<app-dialog-header />

<mat-dialog-content>
    <div class="image-container">
        <img
            *ngIf="data.items[activeIndex] as item"
            [src]="item.url"
            [alt]="item.name"
            loading="lazy">
    </div>

    <button cll-icon-button
            *ngIf="data.items.length > 0"
            (click)="activeIndex = activeIndex - 1"
            [disabled]="activeIndex === 0"
            class="chevron-left"
            cllTooltip="Previous image"
            [cllTooltipEnabled]="activeIndex !== 0">
        <cll-icon>chevron_left</cll-icon>
    </button>

    <button cll-icon-button
            *ngIf="data.items.length > 0"
            (click)="activeIndex = activeIndex + 1"
            [disabled]="activeIndex === data.items.length - 1"
            class="chevron-right"
            cllTooltip="Next image"
            [cllTooltipEnabled]="activeIndex !== data.items.length - 1">
        <cll-icon>chevron_right</cll-icon>
    </button>
</mat-dialog-content>

<mat-dialog-actions>
    <p>{{ activeIndex + 1 }} of {{ data.items.length }}</p>

    <a cll-icon-button
       *ngIf="data.items[activeIndex] as media"
       download
       [href]="media.url"
       cllTooltip="Download image">
        <cll-icon>download</cll-icon>
    </a>
</mat-dialog-actions>
